import * as React from 'react'
import { Container } from '@amzn/dvui/dist/Container'
import { Text } from '@amzn/dvui/dist/Text'
import * as st from './faq.module.scss'
import * as stUtility from '../utilityClasses.module.scss'

import * as WpsRuntime from 'DVWebNodeWpsRuntime'

export interface IFaqProps {
  content?: WpsRuntime.atv.wps.FaqModelProps
}

export const FaqComp = ({ content }: IFaqProps) =>
  content && content.questionList && content.questionList.length ? (
    <Container className={`${stUtility.pageSection} ${st.faq}`} >
      <span data-automation-id="av-faq">
        <div id="faq" className={st.header}>
          <h1><Text string={content.header} /></h1>
        </div>
        <div className={st.questions}>
          <ul>
            {content.questionList.map((q, idx) => <li key={idx}><Text string={q} /></li>)}
          </ul>
          <Text string={content.seeMoreLink} />
        </div>
      </span>
    </Container>) : null

export const Faq = FaqComp
